import { FormatPercentSalesKpi, formatMontoVendors } from "@/utils";

export const getSummaries = (param) => {
  const { columns, data, renderIndex, renderText, emptyText, formatMount } =
    param;
  const sums = [];
  columns.forEach((column, index) => {
    if (index === (renderIndex != undefined ? renderIndex : 0)) {
      sums[index] = renderText != undefined ? renderText : "Totales";
      return;
    }
    const values = data.map((item) => Number(item[column.property]));
    if (!values.every((value) => isNaN(value))) {
      const val = values.reduce((prev, curr) => {
        const value = Number(curr);
        if (!isNaN(value)) {
          return prev + curr;
        } else {
          return prev;
        }
      }, 0);

      if (val >= 0) {
        sums[index] = formatMount != undefined ? formatMount(val) : val;
      }
    } else {
      sums[index] = emptyText != undefined ? emptyText : "N/A";
    }
  });

  return sums;
};

export const getSummariesKPI = (param) => {
  const { columns, data } = param;
  const sums = [];
  columns.forEach((column, index) => {
    if (index === 0) {
      sums[index] = "Totales";
      return;
    }
    const values = data.map((item) => Number(item[column.property]));
    if (!values.every((value) => isNaN(value))) {
      const val = values.reduce((prev, curr) => {
        const value = Number(curr);
        if (!isNaN(value)) {
          return prev + curr;
        } else {
          return prev;
        }
      }, 0);
      sums[index] = FormatPercentSalesKpi(val);
    } else {
      sums[index] = "";
    }
  });
  return sums;
};

export const getTotalByMonthDeals = (param) => {
  const { columns, data } = param;
  const sums = [];
  columns.forEach((column, index) => {
    if (index === 0) {
      sums[index] = "Totales";
      return;
    }

    const values = data.map((item) => Number(item[column.property]));
    if (!values.every((value) => isNaN(value))) {
      //
      const val = values.reduce((prev, curr, index, array) => {
        prev += curr;
        if (index === array.length - 1) {
          return prev / array.length;
        } else {
          return prev;
        }
      }, 0);
      sums[index] = FormatPercentSalesKpi(val);
    } else {
      sums[index] = "";
    }
  });
  return sums;
};
export const getTotalByMonthVendorsAverage = (param) => {
  //Helper de tabla con total en promedios
  const { columns, data } = param;
  const sums = [];
  columns.forEach((column, index) => {
    if (index === 0) {
      sums[index] = "Promedio";
      return;
    }

    const values = data.map((item) => Number(item[column.property]));
    if (!values.every((value) => isNaN(value))) {
      //
      const val = values.reduce((prev, curr, index, array) => {
        prev += curr;
        if (index === array.length - 1) {
          return prev / array.length;
        } else {
          return prev;
        }
      }, 0);
      sums[index] = formatMontoVendors(val);
    } else {
      sums[index] = "";
    }
  });
  return sums;
};
export const getTotalByMonthVendors = (param) => {
  const { columns, data } = param;
  const sums = [];
  columns.forEach((column, index) => {
    if (index === 0) {
      sums[index] = "Totales";
      return;
    }

    const values = data.map((item) => Number(item[column.property]));
    if (!values.every((value) => isNaN(value))) {
      //
      const val = values.reduce((prev, curr) => {
        prev += curr;
        return prev;
      }, 0);
      sums[index] = formatMontoVendors(val);
    } else {
      sums[index] = "";
    }
  });
  return sums;
};
export const getTotalByMonthSLA = (param) => {
  const { columns, data } = param;
  const sums = [];
  columns.forEach((column, index) => {
    if (index === 0) {
      sums[index] = "Totales";
      return;
    }
    const values = data.map((item) => Number(item[column.property]));
    if (!values.every((value) => isNaN(value))) {
      const val = values.reduce((prev, curr, index, array) => {
        prev += curr;
        if (index === array.length - 1) {
          return prev / array.length;
        } else {
          return prev;
        }
      }, 0);
      sums[index] = FormatPercentSalesKpi(val);
    } else {
      sums[index] = "";
    }
  });
  return sums;
};
